module.exports = __webpack_public_path__ + "static/media/EventsLayout.4a6a5543.png";